{
  "schemaVersion": 1,
  "contractRevision": "19",
  "authority": {
    "repository": "Fortemi/fortemi",
    "producerCommit": "Use the immutable Git commit containing this receipt."
  },
  "knowledgeShard": {
    "format": "matric-shard",
    "schemaVersion": "1.2.0",
    "minimumReaderVersion": "1.2.0"
  },
  "profiles": {
    "core-v1": {
      "supported": true,
      "schemaRoot": "contracts/knowledge-shard/1.2.0/core-v1",
      "components": ["notes", "collections", "tags", "templates", "links"]
    },
    "full-v1": {
      "supported": true,
      "status": "supported",
      "candidateComponentSchemaRoot": "contracts/knowledge-shard/1.2.0/full-v1",
      "candidateComponents": [
        "notes",
        "collections",
        "tags",
        "templates",
        "links",
        "embedding_configs",
        "embedding_sets",
        "embedding_set_members",
        "embeddings",
        "note_originals",
        "note_original_history",
        "note_revised_current",
        "note_revisions",
        "provenance_edges",
        "provenance_activities",
        "named_locations",
        "provenance_locations",
        "provenance_devices",
        "provenance_records",
        "skos_schemes",
        "skos_concepts",
        "skos_labels",
        "skos_notes",
        "skos_relations",
        "skos_mapping_relations",
        "skos_scheme_memberships",
        "note_skos_tags",
        "skos_collections",
        "skos_collection_members",
        "graph_sources",
        "graph_edges",
        "communities",
        "community_assignments"
      ],
      "candidateManifestSchema": "contracts/knowledge-shard/1.2.0/full-v1/manifest.schema.json",
      "candidateManifestSchemaSha256": "f6234c53185bb262a253926c81378ea1121a6d9c6021215234ba26c8dcb20c47",
      "candidateManifestFixture": "tests/fixtures/shards/full-v1-manifest-candidate/manifest.json",
      "candidateManifestFixtureSha256": "6bc450e9e3354aeda5ccbc11eb1daa0ea3fda6043f6bbd5a4bb2377f457a47b3",
      "candidateSignatureSchema": "contracts/knowledge-shard/1.2.0/full-v1/signature.schema.json",
      "candidateSignatureSchemaSha256": "8819cd51340fdb04ede977bb83dcbad4af202388a0007a455abb2a28166c97c6",
      "candidateIntegratedArchive": "tests/fixtures/shards/full-v1-integrated-candidate.shard",
      "candidateIntegratedArchiveSha256": "c2e06eaa9802efd25ed70f5fe7e339548bd0b561ae86fb1a0f2d2fdf45305659",
      "candidateIntegratedArchiveReceipt": "tests/fixtures/shards/full-v1-integrated-candidate.shard.receipt.json",
      "candidateIntegratedArchiveReceiptSha256": "e993fd0e037e8ecc5677114b64c05959f93dcf0947b55a1df41f634c38160984",
      "candidateIntegratedArchiveGenerator": "scripts/generate-full-v1-candidate-shard.sh",
      "candidateIntegratedArchiveGeneratorSha256": "ef194b27cf65b6d567c0bb266cee9b4a73062bb5fb01e0a9a23b8fd5a2ab941c",
      "candidateSignatureEnvelopeSha256": "6b289964ed82731b60ec236a34ed565e0c8859ba94c477d56b24cbcc3445032e",
      "candidateSignatureTrust": "deterministic public test fixture; never trust this key in production",
      "exportQuery": "profile=full-v1",
      "mandatoryAttachmentBytes": true,
      "routeRoundTripTest": "tests::shard_full_v1_route_round_trip_preserves_every_component_and_required_blob",
      "candidateGoldenCorpusRoot": "tests/fixtures/shards/full-v1-embedding-candidate",
      "candidateGoldenCorpusSha256": "855375ff9b3b40cac2a42f737865dba7e3cef57e63fc9adda7b1c35ae381df80",
      "candidateRevisionCorpusRoot": "tests/fixtures/shards/full-v1-revision-candidate",
      "candidateRevisionCorpusSha256": "ac0325e9433fbb8d558a10a681a84677bc05bda5d5ae7571d25739712d661c17",
      "candidateProvenanceCorpusRoot": "tests/fixtures/shards/full-v1-provenance-candidate",
      "candidateProvenanceCorpusSha256": "dac91f6de3c472435bf5e880183c3dceffcba5578004da4c6dc9943c1773d84c",
      "candidateSpatialProvenanceCorpusRoot": "tests/fixtures/shards/full-v1-spatial-provenance-candidate",
      "candidateSpatialProvenanceCorpusSha256": "b5310c5156851d80c32d99354333250d74b4df77ff72aa0727474f3ba8692f51",
      "candidateUnifiedProvenanceCorpusRoot": "tests/fixtures/shards/full-v1-unified-provenance-candidate",
      "candidateUnifiedProvenanceCorpusSha256": "0c2794a4e795208992c12e81bbc2fca2061cf07b0473d7bdfd8e2a317168dba1",
      "candidateSkosCorpusRoot": "tests/fixtures/shards/full-v1-skos-candidate",
      "candidateSkosCorpusSha256": "2b277f47456c048cb0a0718406f520afafa58f81ea135347936bd2ba7d2919fb",
      "candidateGraphCorpusRoot": "tests/fixtures/shards/full-v1-graph-candidate",
      "candidateGraphCorpusSha256": "35bae18cb763f28929b1877d32a23317b472b5fa3bd3d5744fc0bea6c460f7b5",
      "remainingReleaseGates": [
        "cross-repository producer and consumer receipts"
      ]
    },
    "record-v1": {
      "supported": true,
      "status": "supported",
      "schemaRoot": "contracts/knowledge-shard/1.2.0/record-v1",
      "components": [
        "notes",
        "collections",
        "tags",
        "links"
      ],
      "requiresLossReport": true,
      "goldenCorpusRoot": "tests/fixtures/shards/record-v1-v1.1-valid",
      "goldenCorpusSha256": "76ad7cdeba3c5935ca39a32044609b0cc826862145910f8450b0d2b5fc128a19",
      "conformanceReceipt": {
        "producerRepository": "Fortemi/fortemi-react",
        "producerCommit": "df4762ad0c470ebd8ee460b56ba71be09b4f1616",
        "archivePath": "tests/fixtures/shards/record-v1-fortemi-react-df4762a.shard",
        "archiveSha256": "3c14a27d5d2cc213ae78e2c89dc524e81eac02cdb414735806c3ce7a3a3af601",
        "receiptPath": "tests/fixtures/shards/record-v1-fortemi-react-df4762a.shard.receipt.json"
      }
    }
  },
  "schemaBundle": {
    "aggregateAlgorithm": "sha256(raw file bytes concatenated in lexicographic path order)",
    "sha256": "deec0cb66dc09865667256e29340d096c02dd9b0e55bdc1ae60b7effb68ac595",
    "files": {
      "contracts/knowledge-shard/1.2.0/core-v1/collection.schema.json": "b1902dfe4aa1cef8079e71ade7caf876d75773f5b0fe906543f54a8a721786b9",
      "contracts/knowledge-shard/1.2.0/core-v1/link.schema.json": "442bc4ec038257071ef4b2e492b335a2f9556b9cce89702843ad4594622d160a",
      "contracts/knowledge-shard/1.2.0/core-v1/manifest.schema.json": "604c2d65bb1ba7a85d4eb5b011c40f97a4cd26b884d30af314d12c4af99ae4ce",
      "contracts/knowledge-shard/1.2.0/core-v1/note.schema.json": "64cdda2c0af1ae2e42cf5b1117f7d5aca94fb55482b7680caf5d5df6dacd040a",
      "contracts/knowledge-shard/1.2.0/core-v1/tag.schema.json": "0517e99584179ec1f974a0e2f5d3ff00597dca0a9460eef6de38266ffb98eb6e",
      "contracts/knowledge-shard/1.2.0/core-v1/template.schema.json": "631187eddfef9c37b8fa91897f9a841c672d5ff5c5ca6dfdd74f94235cc3360b",
      "contracts/knowledge-shard/1.2.0/full-v1/community-assignment.schema.json": "54fe43302a7822cb0157a8c25e2f081878fb575d41ff2a11dd2b7e5e057e6bb0",
      "contracts/knowledge-shard/1.2.0/full-v1/community-set.schema.json": "45b564ffa488dd9db4a0c69a154136671ff05c6dca19b6a687b069b440950621",
      "contracts/knowledge-shard/1.2.0/full-v1/embedding-config.schema.json": "bc2d83b94dede9328dbfff44be978f2c45a5d53284ce7903531e1ddd28eca331",
      "contracts/knowledge-shard/1.2.0/full-v1/embedding-set-member.schema.json": "d56039a9673bdf98491e8ede78bd4dbd68c99a911a9b2beeb5cb0d55363a3528",
      "contracts/knowledge-shard/1.2.0/full-v1/embedding-set.schema.json": "05c96a7d70ec6458dd69fbb73b781f65878930c7de6537cdd8ccc9d6b78269ae",
      "contracts/knowledge-shard/1.2.0/full-v1/embedding.schema.json": "a1c59098a7213830a7f601accb6b277bf8739df6abe8ea6ee89bb9797fa5572a",
      "contracts/knowledge-shard/1.2.0/full-v1/graph-edge.schema.json": "b716b787d93eac042a9c7742443f2dba980fd0d8792c43a697fb6756d2b96544",
      "contracts/knowledge-shard/1.2.0/full-v1/graph-source.schema.json": "d77b79b9776898fdbc0e65622ceb074734a958e4e8b88ca94c74ace429c3ae04",
      "contracts/knowledge-shard/1.2.0/full-v1/manifest.schema.json": "f6234c53185bb262a253926c81378ea1121a6d9c6021215234ba26c8dcb20c47",
      "contracts/knowledge-shard/1.2.0/full-v1/named-location.schema.json": "26e5d78374e5a5e84b61d0eb58ef92ce84d9d1ed9f5642896f4d68871188b137",
      "contracts/knowledge-shard/1.2.0/full-v1/note-skos-tag.schema.json": "128fcf79937135cce2e94fac6f4689a32e984aacd344e0908cbcbbb631c62075",
      "contracts/knowledge-shard/1.2.0/full-v1/note-original-history.schema.json": "e2a01bb6a50e0404e295029b6ac18d2613cdc696305bc2d81961aee8ece32af7",
      "contracts/knowledge-shard/1.2.0/full-v1/note-original.schema.json": "0e23ac2e1076fd5d8e14325d1d14d842ba7fc382f50573777b3cfd15c2730361",
      "contracts/knowledge-shard/1.2.0/full-v1/note-revised-current.schema.json": "05851052e92d54b729ddc77718c279a49662ab7ec172a3a5c19349c8ab0aa6c5",
      "contracts/knowledge-shard/1.2.0/full-v1/note-revision.schema.json": "e4f586683b1157ad4a25cf3216463d40e1501955c85451f30ccb28cecaec1caf",
      "contracts/knowledge-shard/1.2.0/full-v1/provenance-activity.schema.json": "92faf1412d7cf86319266349c6f1a1eb0242c4b6041b5d7525e9735ad10f7fb8",
      "contracts/knowledge-shard/1.2.0/full-v1/provenance-device.schema.json": "80a0de568bdec65f2e2cd2e93a4dc63617984c7493be2450f908e7d81e366c15",
      "contracts/knowledge-shard/1.2.0/full-v1/provenance-edge.schema.json": "7367f6046748805829fb5882ac2798cfe18dae65825e642ead3a4126d3097038",
      "contracts/knowledge-shard/1.2.0/full-v1/provenance-location.schema.json": "923648083efe46eb1f4e88ce9b45f86559baa2b79783861d434ea2ae1c3fff0c",
      "contracts/knowledge-shard/1.2.0/full-v1/provenance-record.schema.json": "e47a21d213b7b4e7612ffad270f22f85886c93b9c461d53a0a493bc1f01c772c",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-collection-member.schema.json": "07818981cea2c9d791321b66e8f18ca82afe381ece3896dd3fa37642a94720f4",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-collection.schema.json": "d9b4700968974672dcf8b86d6ea0ef0c72187cee50fba236cc77678269466962",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-concept.schema.json": "74fda1eed85166be6588b8f9a2684c1c6f4ca88cfdcbb67ac631490935a1fda5",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-label.schema.json": "f951073c51cf2a1de58e5bbf487b78ef01889f90acdd33267600049bf9b69882",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-mapping-relation.schema.json": "07c4195de1a9ef118ed89fb642be01571807ba376b81c7f117fcdfd136e35a39",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-note.schema.json": "ffa06b24e5186fc445417a00712b250f696a38bbf195f63d11526d3588d94c87",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-relation.schema.json": "da8d2f51958bbeee6229fb973fa79dc01da963cf20a3c91ed36772a03903676c",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-scheme-membership.schema.json": "5bd3d6c23116c2404c88cb0d27657d655b900d33f0ecde95096080c1393e334b",
      "contracts/knowledge-shard/1.2.0/full-v1/skos-scheme.schema.json": "2f8d832f20cb3a582f482d5d6056bfa2f831957f64903d2a150fca7aefc48285",
      "contracts/knowledge-shard/1.2.0/full-v1/signature.schema.json": "8819cd51340fdb04ede977bb83dcbad4af202388a0007a455abb2a28166c97c6",
      "contracts/knowledge-shard/1.2.0/record-v1/collection.schema.json": "1337c688e1665ad134793939ebdc6a8f694996fade157f1aec679f015a671cb6",
      "contracts/knowledge-shard/1.2.0/record-v1/link.schema.json": "19f4db2110518b0e2c858cecac2c97ca217833d37881d6c2ab923ee82e93df54",
      "contracts/knowledge-shard/1.2.0/record-v1/manifest.schema.json": "b4e61e330271889de2eb3a122dd1d75a69e9284ee494ea7d302a81e9ece84165",
      "contracts/knowledge-shard/1.2.0/record-v1/note.schema.json": "89b790178b1a4f03051c76d2a42f50a2172c6998c03bceb77592e05a6dd15563",
      "contracts/knowledge-shard/1.2.0/record-v1/tag.schema.json": "5deb8ac3e38006ed15bd9499eab8901089e8ba941196711fca6a8cf5b0f08015"
    }
  },
  "goldenCorpus": {
    "root": "tests/fixtures/shards/core-v1-v1.2-valid",
    "aggregateAlgorithm": "sha256(raw file bytes concatenated in lexicographic path order)",
    "sha256": "a0096f0e7cfc202ade6d32c39bb2c23c8edbd909fbcfec52711fa7f1fe0ef4fe"
  },
  "historicalReleases": {
    "1.0.0/core-v1": {
      "schemaRoot": "contracts/knowledge-shard/1.0.0/core-v1",
      "migrationTo": "1.1.0",
      "schemaBundleSha256": "2520ba0b3a8a020f5c540e88fd31233c7ddbe0d343d1e6a884ed689c8e1d3710",
      "goldenCorpusRoot": "tests/fixtures/shards/core-v1-valid",
      "goldenCorpusSha256": "7e8c529b7f5ac404d27302499c74470e137b03d27fce54111acf8989b1147ae1"
    },
    "1.1.0/core-v1": {
      "schemaRoot": "contracts/knowledge-shard/1.1.0/core-v1",
      "migrationTo": "1.2.0",
      "schemaBundleSha256": "272df54aac6abf90d3d2005c2cf7cf938e3e6e140d4d15d67f2732d9b5108230",
      "goldenCorpusRoot": "tests/fixtures/shards/core-v1-v1.1-valid",
      "goldenCorpusSha256": "7b19ec48e1d5dbf73e7664d7853fafa86227fc042f85c02ada6bbf75941de164"
    }
  },
  "limitations": [
    "schema 1.0.0 note records migrate missing deleted_at to the documented null active-state default",
    "schema 1.1.0 full-v1 embedding records migrate missing contract_fingerprint to the documented null legacy-lineage state",
    "core-v1 attachment records are metadata/reference projections by default; optional verified sidecars do not establish full-v1 conformance",
    "record-v1 covers only notes, collections, tags, note-to-note links, and attachment projections; producers must report every omitted or lossy source concept",
    "full-v1 exports and imports the complete signed-fixture-proven 33-component inventory with strict validation, semantic and revision route round-trip proof, and mandatory deduplicated attachment bytes; cross-repository producer and consumer receipts remain pending",
    "complete absent-versus-null preservation requires a later schema-major or new profile identifier"
  ]
}
